const PLAYERS_UPDATED = (state, players) => {
  state.players = players
}

const SEARCH_UPDATED = (state, q) => {
  state.search = q
}

const COUNTRY_UPDATED = (state, country) => {
  state.country = country
}

const FILTER_UPDATED = (state, filter) => {
  state.filter = filter
}

const PAGINATION_UPDATED = (state, page) => {
  state.pagination.currentPage = page
}

const LOADING_UPDATED = (state, bool) => {
  state.loading = bool
}

const DRAGGING_UPDATED = (state, bool) => {
  state.dragging = bool
}

export default {
  PLAYERS_UPDATED,
  SEARCH_UPDATED,
  COUNTRY_UPDATED,
  FILTER_UPDATED,
  LOADING_UPDATED,
  PAGINATION_UPDATED,
  DRAGGING_UPDATED
}



// WEBPACK FOOTER //
// ./src/store/modules/players/mutations.js